import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { HelpSupportActionTypes } from './constants';
import { createSupport, support, supportAdmin, updateSupport, createChat, getChat, getTicketById } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */
function* createSupportFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createSupport, data);
        if (response.data.status) {
            yield put({
                type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_SUCCESS,
                payload: { ...response.data },
            });
            yield put({
                type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_RESET,
                payload: {},
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_ERROR,
                payload: { ...response.data },
            });
            yield put({
                type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_RESET,
                payload: {},
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_ERROR,
            payload: error,
        });
        yield put({
            type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_RESET,
            payload: {},
        });
    }
}

function* getSupportFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.SUPPORT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(support, data);
        if (response.data.status) {
            yield put({
                type: HelpSupportActionTypes.SUPPORT_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.SUPPORT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.SUPPORT_DATA_ERROR,
            payload: error,
        });
    }
}

function* getSupportAdminFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.SUPPORT_ADMIN_DATA_LOADING,
            payload: {},
        });
        const response = yield call(supportAdmin, data);
        if (response.data.status) {
            yield put({
                type: HelpSupportActionTypes.SUPPORT_ADMIN_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.SUPPORT_ADMIN_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.SUPPORT_ADMIN_DATA_ERROR,
            payload: error,
        });
    }
}

function* updateSupportFunction(payload) {
    try {
        yield put({
            type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_LOADING,
        });

        const response = yield call(updateSupport, payload);

        if (response && response.data && response.data.status === 200) {
            yield put({
                type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_SUCCESS,
                payload: response.data,
            });

            yield put({
                type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_RESET,
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* createChatFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.CREATE_CHAT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createChat, data);
        if (response.data.status) {
            yield put({
                type: HelpSupportActionTypes.CREATE_CHAT_DATA_SUCCESS,
                payload: { ...response.data },
            });
            yield put({
                type: HelpSupportActionTypes.CREATE_CHAT_DATA_RESET,
                payload: {},
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.CREATE_CHAT_DATA_ERROR,
                payload: { ...response.data },
            });
            yield put({
                type: HelpSupportActionTypes.CREATE_CHAT_DATA_RESET,
                payload: {},
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.CREATE_CHAT_DATA_ERROR,
            payload: error,
        });
        yield put({
            type: HelpSupportActionTypes.CREATE_CHAT_DATA_RESET,
            payload: {},
        });
    }
}

function* getChatFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.GET_CHAT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(getChat, data);
        if (response.data) {
            yield put({
                type: HelpSupportActionTypes.GET_CHAT_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.GET_CHAT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.GET_CHAT_DATA_ERROR,
            payload: error,
        });
    }
}
function* getTicketByIdFunction(data) {
    try {
        yield put({
            type: HelpSupportActionTypes.GET_TICKET_BY_ID_LOADING,
            payload: {},
        });
        const response = yield call(getTicketById, data);
        if (response.data) {
            yield put({
                type: HelpSupportActionTypes.GET_TICKET_BY_ID_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: HelpSupportActionTypes.GET_TICKET_BY_ID_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: HelpSupportActionTypes.GET_TICKET_BY_ID_ERROR,
            payload: error,
        });
    }
}

export function* watchCreateSupport() {
    yield takeEvery(HelpSupportActionTypes.CREATE_SUPPORT_DATA_FIRST, createSupportFunction);
    yield takeEvery(HelpSupportActionTypes.CREATE_CHAT_DATA_FIRST, createChatFunction);
}
export function* watchGetSupport() {
    yield takeEvery(HelpSupportActionTypes.SUPPORT_DATA_FIRST, getSupportFunction);
    yield takeEvery(HelpSupportActionTypes.SUPPORT_ADMIN_DATA_FIRST, getSupportAdminFunction);
    yield takeEvery(HelpSupportActionTypes.GET_CHAT_DATA_FIRST, getChatFunction);
    yield takeEvery(HelpSupportActionTypes.GET_TICKET_BY_ID_FIRST, getTicketByIdFunction);
}
export function* watchUpdateSupport() {
    yield takeLatest(HelpSupportActionTypes.UPDATE_SUPPORT_DATA_FIRST, updateSupportFunction);
}
function* supportSaga() {
    yield all([fork(watchCreateSupport), fork(watchGetSupport), fork(watchUpdateSupport)]);
}
export default supportSaga;
